import React from 'react';
import {FormattedMessage} from "react-intl";
import {
  usePaypalPaymentStatusContext
} from '../../contexts/PaypalPaymentStatusContext';
import success from '../../../../common/assets/Check_circle_green.svg';
import cancel from '../../../../common/assets/Cross_circle_red.svg';
import styles from './Message.module.scss';

const Message = () => {
  const {status} = usePaypalPaymentStatusContext();
  const getMessage = () => {
    switch (status) {
      case 'success':
        return (
          <div className={styles.container}>
            <img src={success} alt="i" className={styles.icon}/>
            <div className={styles.message}>
              <FormattedMessage
                id={'payPalPaymentStatus-success'}
                defaultMessage={'Thank you for paying using PayPal, the payment was successful!'}
              />
            </div>
          </div>
        )
      case 'cancel':
        return (
          <div className={styles.container}>
            <img src={cancel} alt="i" className={styles.icon}/>
            <div className={styles.message}>
              <FormattedMessage
                id={'payPalPaymentStatus-cancel'}
                defaultMessage={'Payment failed, please try again or contact support!'}
              />
            </div>
          </div>
        )
      default:
        return (
          <div className={styles.container}>
            <h2 className={styles.notFoundHeader}>404</h2>
            <div className={styles.message}>
              <FormattedMessage
                id={'page-not-found-404'}
                defaultMessage={'Page not found!'}
              />
            </div>
          </div>
        )
    }
  };

  return getMessage();
};

export default Message;
